import { render, staticRenderFns } from "./SingleService.vue?vue&type=template&id=2e75de52&scoped=true&"
import script from "./SingleService.vue?vue&type=script&lang=js&"
export * from "./SingleService.vue?vue&type=script&lang=js&"
import style0 from "./SingleService.vue?vue&type=style&index=0&id=2e75de52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e75de52",
  null
  
)

export default component.exports